export default __webpack_public_path__ + "static/gijn-logo-white-0639fe636aa4de2eda1b1f4c98ac274c.png";